// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-0b90026e] {\n  min-width: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
